import { memo } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter } from "../../../../components";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../../../redux/actions/modals";

const OrderPlacedSuccess = () => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const handleClose = () => {
        dispatch(handleModal([{ "ORDER_PLACE_SUCCEFULL": false }]));
    };
    return (
        <BzModal show={modals['ORDER_PLACE_SUCCEFULL']} onHide={handleClose} centered>
            <BzModalBody className='bdr-btm'>;
                <Container fluid className='p-0'>
                    <Row className='g-0 pt-5  pb-4'>
                        <Col className='d-flex justify-content-center'>
                            <div className='icon-64 icon-checktick icon-positive'>&nbsp;</div>
                        </Col>
                    </Row>
                    <Row className='g-0 px-3 mrgauto'>
                        <Col className='flex-column justify-content-center'>
                            <div className='font-medium font-size6 color-text text-center'>Your NFO order has</div>
                            <div className='font-medium font-size6 color-text text-center pb-4'>been placed successfully</div>
                            <div className='font-regular font-size4 color-subtext text-center pb-5'>Order ID: NWTAJ0000221</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>

            <BzModalFooter className='p-3'>
                <Container fluid className='p-0'>
                    <Row className='g-0 justify-content-end'>                        
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline btn-block me-3' onClick={handleClose}>CLOSE</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary btn-block ms-3'>ORDER STATUS</BzButton>
                        </Col>                       
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal >

    );
};

export default memo(OrderPlacedSuccess);